<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%;">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Üzlet kategóriák</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/data/shops/categories/add')"
            icon="el-icon-plus"
            v-can="'shopcategory.create'"
          >
            Új Kategória
          </el-button>
        </div>
        <list />
        <template v-if="$route.meta.showAddShopCategoryDialog">
          <shop-category-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateShopCategoryDialog">
          <shop-category-dialog
            :shopCategoryId="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../../components/data/shops/Sidebar';
  import List from '../../../components/data/shops/categories/List';
  import ShopCategoryDialog from '../../../components/data/shops/categories/Dialog';

  export default {
    components: {
      Sidebar,
      List,
      ShopCategoryDialog,
    }
  };
</script>
